import { render, staticRenderFns } from "./IconsUsersStatus.vue?vue&type=template&id=fbb7e238&scoped=true&"
import script from "./IconsUsersStatus.vue?vue&type=script&lang=js&"
export * from "./IconsUsersStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb7e238",
  null
  
)

export default component.exports